import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axios";
import { entitiesConfig } from "../../components/templateComponents/constants";
import "./index.css";

const LocationSelector = ({ onFloorSelect }) => {
  const [establishments, setEstablishments] = useState({});
  const [campuses, setCampuses] = useState({});
  const [buildings, setBuildings] = useState({});
  const [floors, setFloors] = useState({});

  const [selectedEstablishment, setSelectedEstablishment] = useState("");
  const [selectedCampus, setSelectedCampus] = useState("");
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const [selectedFloor, setSelectedFloor] = useState("");

  const endpoints = entitiesConfig.locationSelector.endpoints;

  useEffect(() => {
    axiosInstance
      .post(endpoints.establishments, { view_type: "view" })
      .then((res) => {
        if (res.data?.Status === "Success") setEstablishments(res.data.Data);
        else setEstablishments({});
      })
      .catch((err) => {
        console.error("Error fetching establishments:", err);
        setEstablishments({});
      });
  }, []);

  useEffect(() => {
    if (selectedEstablishment) {
      axiosInstance
        .post(endpoints.campuses, {
          view_type: "view",
          est_id: selectedEstablishment,
        })
        .then((res) => {
          if (res.data?.Status === "Success") setCampuses(res.data.Data);
          else setCampuses({});
          resetSelections("campus");
        })
        .catch((err) => {
          console.error("Error fetching campuses:", err);
          setCampuses({});
        });
    }
  }, [selectedEstablishment]);

  useEffect(() => {
    if (selectedCampus) {
      localStorage.setItem("selectedCampusId", selectedCampus);
      axiosInstance
        .post(endpoints.buildings, {
          view_type: "view",
          campusid: selectedCampus,
        })
        .then((res) => {
          if (res.data?.Status === "Success") setBuildings(res.data.Data);
          else setBuildings({});
          resetSelections("building");
        })
        .catch((err) => {
          console.error("Error fetching buildings:", err);
          setBuildings({});
        });
    }
  }, [selectedCampus]);

  useEffect(() => {
    if (selectedBuilding) {
      localStorage.setItem("selectedBuildingId", selectedBuilding);
      axiosInstance
        .post(endpoints.floors, {
          view_type: "view all",
          bldg_id: selectedBuilding,
        })
        .then((res) => {
          if (res.data?.Status === "Success") {
            const floorsData = {};
            res.data.Data.forEach((floor) => {
              floorsData[floor.floor_ids] = floor.bldg_floorname;
            });
            setFloors(floorsData);
          } else {
            setFloors({});
          }
          setSelectedFloor("");
          onFloorSelect("");
        })
        .catch((err) => {
          console.error("Error fetching floors:", err);
          setFloors({});
        });
    }
  }, [selectedBuilding]);

  useEffect(() => {
    onFloorSelect(selectedFloor);
  }, [selectedFloor, onFloorSelect]);

  const resetSelections = (level) => {
    if (level === "campus") {
      setSelectedCampus("");
      setBuildings({});
      setSelectedBuilding("");
      setFloors({});
      setSelectedFloor("");
      onFloorSelect("");
    } else if (level === "building") {
      setSelectedBuilding("");
      setFloors({});
      setSelectedFloor("");
      onFloorSelect("");
    }
  };

  return (
    <div className="beacon-mapper-dropdown-container">
      <div className="beacon-mapper-dropdown-item">
        <label htmlFor="establishment">Establishment</label>
        <select
          id="establishment"
          value={selectedEstablishment}
          onChange={(e) => setSelectedEstablishment(e.target.value)}
          className="beacon-mapper-select"
        >
          <option value="" disabled>Select Establishment</option>
          {Object.entries(establishments).map(([id, name]) => (
            <option key={id} value={id}>{name}</option>
          ))}
        </select>
      </div>

      <div className="beacon-mapper-dropdown-item">
        <label htmlFor="campus">Campus</label>
        <select
          id="campus"
          value={selectedCampus}
          onChange={(e) => setSelectedCampus(e.target.value)}
          className="beacon-mapper-select"
          disabled={!selectedEstablishment || Object.keys(campuses).length === 0}
        >
          <option value="" disabled>Select Campus</option>
          {Object.entries(campuses).map(([id, name]) => (
            <option key={id} value={id}>{name}</option>
          ))}
        </select>
      </div>

      <div className="beacon-mapper-dropdown-item">
        <label htmlFor="building">Building</label>
        <select
          id="building"
          value={selectedBuilding}
          onChange={(e) => setSelectedBuilding(e.target.value)}
          className="beacon-mapper-select"
          disabled={!selectedCampus || Object.keys(buildings).length === 0}
        >
          <option value="" disabled>Select Building</option>
          {Object.entries(buildings).map(([id, name]) => (
            <option key={id} value={id}>{name}</option>
          ))}
        </select>
      </div>

      <div className="beacon-mapper-dropdown-item">
        <label htmlFor="floor">Floor</label>
        <select
          id="floor"
          value={selectedFloor}
          onChange={(e) => setSelectedFloor(e.target.value)}
          className="beacon-mapper-select"
          disabled={!selectedBuilding || Object.keys(floors).length === 0}
        >
          <option value="" disabled>Select Floor</option>
          {Object.entries(floors).map(([floorId, name]) => (
            <option key={floorId} value={floorId}>{name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LocationSelector;
